<template>
    <div id="case">
        <Header></Header>
        <div class="case-img"></div>
    </div>
</template>

<script>
    import Header from '../pages/header/header'
    import {onloadRefresh} from '../utils/imgRefresh'
    export default {
        name: "cyb",
        components:{
            Header
        },
        mounted() {
            onloadRefresh(this,require(`../assets/cyb/车衣宝.png`))
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/public";

</style>
